// src/components/Customization.js
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import ThemeContext from '../context/ThemeContext';
import Button from '../components/Button';

const CustomizationContainer = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.mainBody};
  color: ${({ theme }) => theme.mainText};
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const Label = styled.label`
  display: block;
  margin: 15px 0 5px;
  font-weight: bold;
  color: ${({ theme }) => theme.mainText};
`;

const ColorPicker = styled.input`
  width: 100px;
  height: 40px;
  border: none;
  cursor: pointer;
  margin: 5px;
`;

const ThemeSelector = styled.select`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.mainText};
  background-color: ${({ theme }) => theme.mainField};
  color: ${({ theme }) => theme.mainText};
`

const ThemePreview = styled.div`
  padding: 20px;
  margin: 20px 0;
  border: 2px dashed ${({ theme }) => theme.mainAccent};
  border-radius: 12px;
  text-align: center;
  background-color: ${({ theme }) => theme.mainField};
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`

const Customization = () => {
  const { theme, updateTheme, predefinedThemes } = useContext(ThemeContext);
  const [selectedTheme, setSelectedTheme] = useState('light');
  const [customTheme, setCustomTheme] = useState(theme);

  const handleThemeChange = (e) => {
    const newTheme = e.target.value;
    setSelectedTheme(newTheme);

    if (newTheme !== 'custom') {
      updateTheme(predefinedThemes[newTheme]);
    }
  };

  const handleCustomThemeChange = (color, key) => {
    setCustomTheme({ ...customTheme, [key]: color });
  }

  const handleSaveCustomTheme = () => {
    updateTheme(customTheme);
  }

  return (
    <CustomizationContainer theme={theme}>
      <h1>Customize Your Experience</h1>

      <Label>Choose a Theme</Label>
      <ThemeSelector value={selectedTheme} onChange={handleThemeChange} theme={theme}>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="cool">Cool</option>
        <option value="me">Me</option>
        <option value="custom">Custom</option>
      </ThemeSelector>

      {selectedTheme === 'custom' && (
        <div>
          <Label>Main Body Color</Label>
          <ColorPicker
            type="color"
            value={customTheme.mainBody}
            onChange={(e) => handleCustomThemeChange(e.target.value, 'mainBody')}
          />

          <Label>Main Field Color</Label>
          <ColorPicker
            type="color"
            value={customTheme.mainField}
            onChange={(e) => handleCustomThemeChange(e.target.value, 'mainField')}
          />

          <Label>Main Text Color</Label>
          <ColorPicker
            type="color"
            value={customTheme.mainText}
            onChange={(e) => handleCustomThemeChange(e.target.value, 'mainText')}
          />

          <Label>Main Accent Color</Label>
          <ColorPicker
            type="color"
            value={customTheme.mainAccent}
            onChange={(e) => handleCustomThemeChange(e.target.value, 'mainAccent')}
          />

          <Button theme={theme} onClick={handleSaveCustomTheme}>
            Save Custom Theme
          </Button>
        </div>
      )}

      <ThemePreview theme={selectedTheme === 'custom' ? customTheme : predefinedThemes[selectedTheme]}>
        <h2>Preview of Selected Theme</h2>
        <p>This is how your homepage will look with the selected theme.</p>
      </ThemePreview>
    </CustomizationContainer>
  );
};

export default Customization;
